import { EEvolveLandingPageTabs, thunkActionLoading } from '@configs'
import { zodResolver } from '@hookform/resolvers/zod'
import {
  getEvolvePageSeoAction,
  updateEvolvePageSeoAction,
  useAppDispatch,
  useAppSelector,
} from '@redux'
import { Skeleton, message } from 'antd'
import { Fragment, useEffect } from 'react'
import { useForm } from 'react-hook-form'
import { Button } from 'src/common'
import { EMediaCategory } from 'src/interfaces/gallery'
import MetaTab from 'src/pages/blog/content/MetaTab'
import { IEvolveSeoPageSchema, evolvePageSeoSchema } from './seoConfigSchema'

interface IAboutUsPageSeoProps {
  activeTab: string
}

const EvolvePageSeo = ({ activeTab }: IAboutUsPageSeoProps) => {
  const dispatch = useAppDispatch()

  const configSeo = useAppSelector((state) => state.evolveLanding.evolveSeo)
  const isGetSeoActionLoading = useAppSelector(
    (state) =>
      state.evolveLanding?.loadings[
        thunkActionLoading.GET_EVOLVE_SEO_CONFIG_LOADING
      ]
  )

  const isUpdating = useAppSelector(
    (state) =>
      state.evolveLanding?.loadings[
        thunkActionLoading.UPDATE_EVOLVE_SEO_CONFIG_LOADING
      ]
  )

  const { handleSubmit, control, setValue, getValues } =
    useForm<IEvolveSeoPageSchema>({
      defaultValues: {
        metaTitle: '',
        metaDescription: '',
        metaImage: '',
        canonical: '',
        schemaMarkup: 'schema mark up',
        keywords: '',
      },
      resolver: zodResolver(evolvePageSeoSchema),
      mode: 'onSubmit',
      reValidateMode: 'onChange',
    })

  const onSubmit = async (data: IEvolveSeoPageSchema) => {
    try {
      const response = await dispatch(updateEvolvePageSeoAction(data)).unwrap()

      if (response.success) {
        message.success(response?.message ?? '')
      }
    } catch (error: any) {
      message.error(error?.message ?? '')
    }
  }

  const handleClickSave = () => {
    handleSubmit(onSubmit)()
  }

  useEffect(() => {
    if (activeTab === EEvolveLandingPageTabs.SEO_CONFIG) {
      const getEvolvePageSeo = async () => {
        try {
          dispatch(getEvolvePageSeoAction()).unwrap()
        } catch (error: any) {
          message.error(error?.message ?? '')
        }
      }
      getEvolvePageSeo()
    }
  }, [activeTab])

  useEffect(() => {
    if (configSeo) {
      setValue('metaTitle', configSeo?.metaData?.metaTitle || '')
      setValue('metaDescription', configSeo?.metaData?.metaDescription || '')
      setValue('metaImage', configSeo?.metaData?.metaImage || '')
      setValue('canonical', configSeo?.metaData?.canonical || '')
      setValue('keywords', configSeo?.metaData?.keywords || '')
    }
  }, [configSeo])
  return (
    <Fragment>
      {isGetSeoActionLoading ? (
        <>
          <Skeleton
            paragraph={{ rows: 4 }}
            style={{
              marginTop: 10,
            }}
          />
        </>
      ) : (
        <div className="bg-white">
          <MetaTab
            activeTab={activeTab}
            control={control}
            getValues={getValues}
            setValue={setValue}
            isShowSelectMedia
            category={EMediaCategory.CONTENT}
          />

          <div className="term-policy-action mr-5 pb-5 flex items-center justify-end gap-6">
            <Button
              type="primary"
              size="small"
              id="blog-form"
              onClick={() => {
                handleClickSave()
              }}
              loading={isUpdating || isGetSeoActionLoading}
            >
              Save
            </Button>
          </div>
        </div>
      )}
    </Fragment>
  )
}

export default EvolvePageSeo
